<template>
  <Modal
    v-model="_value"
    width="500"
    title="BSJ设置车牌号"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setupRegistration" autoComplete="on" v-model="setupRegistration"
          class="card-box login-form">

      <Form-item label="车牌号码">
        <Input v-model="setupRegistration.registrationNum" placeholder="车牌号码"
               style="width: 100px;"></Input>
      </Form-item>

      <Form-item label="车牌颜色">
        <Select v-model="setupRegistration.registrationColor">
          <Option value=1 key=1>蓝色</Option>
          <Option value=2 key=2>黄色</Option>
          <Option value=3 key=3>黑色</Option>
          <Option value=4 key=4>白色</Option>
          <Option value=5 key=5>绿色</Option>
        </Select>
      </Form-item>

      <Button type="primary" @click="onSetupRegistration">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'


export default {
  name: 'bsjsetdrivervehicleinforegistrationnummodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setupRegistration: {
        id: 0,
        registrationNum: null,
        registrationColor: 0
      },

    }
  },
  methods: {
    ...mapActions([
    ]),
    visibleChange (val) {
      if (val) {
        this.setupRegistration.id = this._initValue
        this.setupRegistration.registrationNum = null
        this.setupRegistration.registrationColor = 0
      }
    },
    onCleanDriverCardParams () {
      this.setupRegistration.registrationNum = null
      this.setupRegistration.registrationColor = 0
    },
    onSetupRegistration () {
      store.dispatch('NetCommandServ_SetupRegistration', {
        params: this.setupRegistration
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
